<template>
  <canvas :id="idChart" />
</template>

<script>
export default {
  props: [
    'idChart',
    'values',
    'labels',
    'thickness',
    'colors',
    'title',
    'positionLegend',
    'titleColor',
    'titleUpperCase',
    'subLabels',
  ],

  data() {
    return {
      colorTitle: '#3A18D1',
      upperCaseTitle: true,
      isTitle: true,
    };
  },
  mounted() {
    let datasets = [];

    this.values.forEach((value) => {
      datasets.push({
        data: value,
        backgroundColor: this.colors,
      });
    });

    //Define title color if it's defined in props
    if (this.titleColor != null) {
      this.colorTitle = this.titleColor;
    }

    if (this.titleUpperCase != null) {
      this.upperCaseTitle = this.titleUpperCase;
    }

    if (this.title == '') {
      this.isTitle = false;
    }

    let positionLegend = 'bottom';
    if (this.positionLegend) {
      if (window.matchMedia('(max-width: 1439px)').matches) {
        //If screen too small, legend at bottom
        positionLegend = 'bottom';
      } else {
        positionLegend = this.positionLegend;
      }
    }
    let displayLegend = true;
    if (window.matchMedia('(max-width: 768px)').matches) {
      displayLegend = false;
    }

    let ctx = document.getElementById(this.idChart);

    let myChart = new Chart(ctx, {
      type: 'pie',
      data: {
        subLabels: this.subLabels,
        labels: this.labels,
        datasets: datasets,
      },
      options: {
        cutoutPercentage: this.thickness,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: displayLegend,
          position: positionLegend,
          labels: {
            fontColor: '#919AA6',
            fontSize: 13,
            fontFamily: 'Montserrat',
            usePointStyle: true,
          },
        },
        title: {
          display: this.isTitle,
          text: this.upperCaseTitle ? this.title.toUpperCase() : this.title,
          fontSize: 18,
          fontFamily: 'Montserrat',
          fontColor: this.colorTitle,
          padding: 35,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let datasetIndex = tooltipItem.datasetIndex ? 1 : 0;
              let valueIndex = tooltipItem.index ? 1 : 0;

              return (
                data.subLabels[datasetIndex] +
                ' : ' +
                data.datasets[datasetIndex]['data'][valueIndex] +
                ' ' +
                data.labels[valueIndex]
              );
            },
          },
        },
      },
    });
  },
};
</script>
